<template lang="pug">
  div
    v-alert(v-if="error.text" type="error")
      p К сожалению в работе ЭП возникла проблема: {{ error.text }}
      p.mb-0(v-if="error.description" v-html="error.description")
    template(v-else)
      v-select(
        v-model="selectedCertificate"
        :loading="loadingCertificates"
        :items="certificates"
        item-text="name"
        label="Выберите сертификат"
        return-object
        outlined rounded
      )

      //- v-alert(type="info" outlined)
      //-   template(v-if="loadingFiles && !targetFiles.length")
      //-     slot(name="loading")
      //-       span Загрузка документов...
      //-       v-progress-linear(
      //-         v-if="!targetFiles.length"
      //-         color="theme"
      //-         indeterminate
      //-         rounded
      //-         height="6"
      //-       )
      //-   template(v-else-if="!targetFiles.length")
      //-     slot(name="no-data")
      //-       span Документы для подписания отсутствуют
      //-   template(v-else)
      //-     slot(name="items" v-bind="{ items: targetFiles }")
      //-       span.mr-1 Будут подписаны следующие документы:
      //-       file-signature-chip.mr-2.my-1(
      //-         v-for="(file, index) in targetFiles"
      //-         :signature="file"
      //-         :key="index"
      //-       )
      slot(v-bind="{ targetFiles }")
    v-card-actions.px-0(v-if="!hideActions")
      slot(name="prepend-action")
      v-spacer
      v-btn(
        :disabled="disabledSign"
        :loading="loading"
        color="success"
        @click="signFiles"
      ) {{ signBtnText }}
        v-icon(right) mdi-key
      slot(name="append-action")
</template>

<script>
import { getUserCertificates } from 'crypto-pro';

import Signature from './signature';
import FileSignatureChip from './FileSignatureChip.vue';

const DEFAULT_ERROR_DESCRIPTION = 'Велика вероятность того, что у вас не установлен плагин КриптоПро  для работы с ЭП в браузере '
  + '(ссылка: <a class="secondary--text text--lighten-3" href="https://cryptopro.ru/products/cades/plugin/get_2_0" target="_blank">'
  + 'https://cryptopro.ru/products/cades/plugin/get_2_0</a>)';
// const files = [{
//   is: type File,
//   url: type string,
//   originalName: type string(with format),
// }];

export default {
  name: 'FileSignature',
  components: {
    FileSignatureChip,
  },
  props: {
    value: { type: Array, default: () => ([]) },
    files: { type: Array, default: () => ([]) },
    successCallback: { type: Function, default: () => null },
    disabled: { type: Boolean, default: false },
    signBtnText: { type: String, default: 'Подписать' },
    hideActions: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      loadingCertificates: false,
      loadingFiles: false,
      selectedCertificate: null,
      certificates: [],
      targetFiles: [],
      error: {
        text: null,
        description: null,
      },
    };
  },
  computed: {
    disabledSign() {
      const {
        disabled, error, loadingCertificates, loadingFiles, targetFiles,
      } = this;
      return disabled || Boolean(error.text)
        || loadingCertificates || loadingFiles || targetFiles.every((f) => f.signed);
    },
    namesFiles() {
      return this.targetFiles.map((sigFile) => sigFile.file.name).join(', ');
    },
    stringifyFiles() {
      return JSON.stringify(this.files);
    },
  },
  watch: {
    stringifyFiles() {
      this.setTargetFiles();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        this.loadingCertificates = true;
        this.certificates = await getUserCertificates();
        this.loadingCertificates = false;
        [this.selectedCertificate] = this.certificates;
        console.log(await this.setTargetFiles());
        if (this.files.length) await this.setTargetFiles();
      } catch (error) {
        this.error.text = error.message;
        this.error.description = DEFAULT_ERROR_DESCRIPTION;
      }
      this.$emit('init');
    },
    async setTargetFiles() {
      this.loadingFiles = true;
      const { files } = this;
      const isPromise = !files.every((file) => file.is);
      if (isPromise) {
        const promises = files.map((file) => new Promise((resolve, reject) => {
          const fileName = file?.originalName ?? file?.is?.name ?? file.url.split('/').at(-1);
          if (file.is) {
            resolve(new Signature(file.is));
          } else {
            fetch(file.url).then((res) => {
              res.blob().then((blob) => {
                resolve(new Signature(new File([blob], fileName, { type: blob.type })));
              });
            }).catch(() => reject);
          }
        }));
        this.targetFiles = await Promise.all(promises);
      } else this.targetFiles = files.map((file) => new Signature(file.is));
      this.loadingFiles = false;
    },
    signFiles() {
      this.loading = true;
      const promises = this.targetFiles.map((sigFile) => sigFile.sign(this.selectedCertificate));
      return Promise.all(promises)
        .then(
          (result) => {
            this.$emit('input', result);
            this.successCallback(result);
            return result;
          },
          (reason) => {
            this.$toasted.error(reason.message);
            return reason.message;
          },
        ).finally(() => { this.loading = false; });
    },
  },
};
</script>
